var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMsg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 15.8906H4.6875C2.10281 15.8906 0 13.7878 0 11.2031V4.79688C0 2.21219 2.10281 0.109375 4.6875 0.109375H15.3125C17.8972 0.109375 20 2.21219 20 4.79688V11.2031C20 13.7878 17.8972 15.8906 15.3125 15.8906ZM4.6875 1.67188C2.96438 1.67188 1.5625 3.07375 1.5625 4.79688V11.2031C1.5625 12.9263 2.96438 14.3281 4.6875 14.3281H15.3125C17.0356 14.3281 18.4375 12.9263 18.4375 11.2031V4.79688C18.4375 3.07375 17.0356 1.67188 15.3125 1.67188H4.6875ZM12.8627 9.38305L16.7243 6.43336C17.0671 6.17145 17.1328 5.68117 16.8709 5.33828C16.6089 4.99539 16.1187 4.92977 15.7758 5.19168L11.9147 8.14102C10.7998 8.99137 9.24285 8.99199 8.12723 8.14316L4.38578 5.23477C4.04512 4.96992 3.55426 5.03145 3.28949 5.37211C3.02469 5.71277 3.08617 6.20359 3.42684 6.4684L7.17117 9.37902C7.17305 9.38051 7.17496 9.38195 7.17688 9.3834C8.01375 10.0217 9.01648 10.3408 10.0195 10.3408C11.0224 10.3408 12.0256 10.0215 12.8627 9.38305Z",
    fill: "#0061DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/msg.15a30173a8656575675d5f369ef41328.svg";
export { ForwardRef as ReactComponent };